<template>
  <div class="content-container flex-row">
    <TheLoader :active="loading || updating" :update="updating" :small="true"/>

    <section class="content xlarge-padding white">
      <div class="scroll-section">
        <fieldset class="card">
          <div class="grid-x grid-padding-x">
            <TheSelectInput
              v-model="form.Avdelingsid"
              containerClassName="cell medium-3"
              label="Velg avdeling" name="Avdelingsid"
              required
              v-validate="'required'"
              :items="instillinger.avdeling"
              :disabled="$store.getters.isFormLoading"
            />
            <TheSelectInput
              v-model="form.Status"
              containerClassName="cell medium-3"
              label="Velg status" name="Status"
              :items="instillinger.status"
              :disabled="$store.getters.isFormLoading || selectedAvdeling === null"
            />
            <TheSelectInput
              v-model="form.AvantiType"
              containerClassName="cell medium-3"
              label="Velg type" name="AvantiType"
              :items="instillinger.avantitypes"
              :disabled="$store.getters.isFormLoading || selectedAvdeling === null"
            />
            <div class="cell medium-3">
              <div class="input-container">
                <label>&nbsp;</label>
                <span class="show-more-opts" v-if="!showAdvanced"><a href="javascript:;" @click="showAdvanced = !showAdvanced">&raquo; Vis fler valg...</a></span>
                <span class="show-more-opts" v-else><a href="javascript:;" @click="showAdvanced = !showAdvanced">&raquo; Vis færre valg...</a></span>
              </div>
            </div>
          </div>

          <div class="card" v-if="showAdvanced">
            <div class="grid-x">
              <div class="cell medium-12">
                <TheAutoCompleteInputButtonOuter
                  v-model.trim="kundeInputValue"
                  name="Kundenr"
                  maxlength="10"
                  :placeholder="'Finn kunde'"
                  :label="'Tilhørende kunde: ' + (this.form.Kundenr ? this.form.Kundenr : '-')"
                  :onInputCallback="onKundeSearchInput"
                  :onSelectCallback="onKundeSearchSelected"
                  :onResetCallback="onKundeSearchReset"
                  :minquery="2"
                  :disabled="$store.getters.isFormLoading || selectedAvdeling === null"
                >
                  <div slot="item" slot-scope="props">
                    <span v-if="props.item.Bedrift"><strong>{{props.item.Kundenr}}</strong>, {{props.item.FirmaNavn}}</span>
                    <span v-else-if="props.item.full_name"><strong>{{props.item.Kundenr}}</strong>, {{props.item.full_name}}</span>
                    <span v-else><strong>{{props.item.Kundenr}}</strong></span>
                  </div>
                </TheAutoCompleteInputButtonOuter>
              </div>
            </div>

            <div class="grid-x grid-padding-x">
              <div class="cell medium-12">
                <TheAutoCompleteInputButtonOuter
                  v-model.trim="auksjonInputValue"
                  name="Auksjon"
                  maxlength="10"
                  :placeholder="'Finn auksjon'"
                  :label="'Tilhørende auksjon: ' + (this.form.Auksjonskode ? this.form.Auksjonskode : '-')"
                  :onInputCallback="onAuksjonSearchInput"
                  :onSelectCallback="onAuksjonSearchSelected"
                  :onResetCallback="onAuksjonSearchReset"
                  :minquery="2"
                  :disabled="$store.getters.isFormLoading || selectedAvdeling === null"
                >
                  <div slot="item" slot-scope="props">
                    <strong>{{props.item.Auksjon}}</strong>, {{props.item.Beskrivelse}}
                    <span v-if="props.item.Auksjon_dato">
                      ({{ props.item.Auksjon_dato | avantidate }})
                    </span>
                  </div>
                </TheAutoCompleteInputButtonOuter>
              </div>

              <div class="cell medium-4">
                <label for="fra">Auksjon dato, f.o.m:</label>
                <div class="input-container no-margin">
                  <b-datepicker
                    @input="(date) => formatDate(date, 'Auksjonsdato_fra')"
                    :show-week-number="false"
                    :first-day-of-week="1"
                    :editable="false"
                    :disabled="$store.getters.isFormLoading || selectedAvdeling === null"
                    v-model="form.Auksjonsdato_fra"
                    name="Auksjonsdato_fra"
                    placeholder="Vis kalender..."
                    icon="calendar-today"
                    ref="Auksjonsdato_fra"
                    id="Auksjonsdato_fra">
                    <button class="button disabled" v-if="!form.Auksjonsdato_fra" @click.prevent="$refs.Auksjonsdato_fra.toggle()"><span>Slett dato</span></button>
                    <button class="button" v-else @click.prevent="form.Auksjonsdato_fra = null"><span>Slett dato</span></button>
                  </b-datepicker>
                  <span class="glyph">
                    <svg viewBox="0 0 44 44"><use xlink:href="/static/sprites.svg#glyph-input-date"></use></svg>
                  </span>
                </div>
              </div>
              <div class="cell medium-4">
                <label for="til">Auksjon dato, t.o.m:</label>
                <div class="input-container">
                  <b-datepicker
                    @input="(date) => formatDate(date, 'Auksjonsdato_til')"
                    :show-week-number="false"
                    :first-day-of-week="1"
                    :editable="false"
                    :disabled="$store.getters.isFormLoading || selectedAvdeling === null"
                    v-model="form.Auksjonsdato_til"
                    name="Auksjonsdato_til"
                    placeholder="Vis kalender..."
                    icon="calendar-today"
                    ref="Auksjonsdato_til"
                    id="Auksjonsdato_til">
                    <button class="button disabled" v-if="!form.Auksjonsdato_til" @click.prevent="$refs.Auksjonsdato_til.toggle()"><span>Slett dato</span></button>
                    <button class="button" v-else @click.prevent="form.Auksjonsdato_til = null"><span>Slett dato</span></button>
                  </b-datepicker>
                  <span class="glyph">
                    <svg viewBox="0 0 44 44"><use xlink:href="/static/sprites.svg#glyph-input-date"></use></svg>
                  </span>
                </div>
              </div>
              <div class="cell medium-4"></div>

              <div class="cell medium-4">
                <label for="fra">Generert dato, f.o.m:</label>
                <div class="input-container no-margin">
                  <b-datepicker
                    @input="(date) => formatDate(date, 'Dato_fra')"
                    :show-week-number="false"
                    :first-day-of-week="1"
                    :editable="false"
                    :disabled="$store.getters.isFormLoading || selectedAvdeling === null"
                    v-model="form.Dato_fra"
                    name="Dato_fra"
                    placeholder="Vis kalender..."
                    icon="calendar-today"
                    ref="Dato_fra"
                    id="Dato_fra">
                    <button class="button disabled" v-if="!form.Dato_fra" @click.prevent="$refs.Dato_fra.toggle()"><span>Slett dato</span></button>
                    <button class="button" v-else @click.prevent="form.Dato_fra = null"><span>Slett dato</span></button>
                  </b-datepicker>
                  <span class="glyph">
                    <svg viewBox="0 0 44 44"><use xlink:href="/static/sprites.svg#glyph-input-date"></use></svg>
                  </span>
                </div>
              </div>
              <div class="cell medium-4">
                <label for="til">Generert dato, t.o.m:</label>
                <div class="input-container">
                  <b-datepicker
                    @input="(date) => formatDate(date, 'Dato_til')"
                    :show-week-number="false"
                    :first-day-of-week="1"
                    :editable="false"
                    :disabled="$store.getters.isFormLoading || selectedAvdeling === null"
                    v-model="form.Dato_til"
                    name="Dato_til"
                    placeholder="Vis kalender..."
                    icon="calendar-today"
                    ref="Dato_til"
                    id="Dato_til">
                    <button class="button disabled" v-if="!form.Dato_til" @click.prevent="$refs.Dato_til.toggle()"><span>Slett dato</span></button>
                    <button class="button" v-else @click.prevent="form.Dato_til = null"><span>Slett dato</span></button>
                  </b-datepicker>
                  <span class="glyph">
                    <svg viewBox="0 0 44 44"><use xlink:href="/static/sprites.svg#glyph-input-date"></use></svg>
                  </span>
                </div>
              </div>
              <div class="cell medium-4"></div>
            </div>
          </div>
        </fieldset>
      </div>

      <table class="large fixed visible" style="width: 100%">
      <thead>
        <tr>
          <th>&nbsp;</th>
          <th>ID</th>
          <th>Kundenr</th>
          <th>Navn</th>
          <th>Auksjon</th>
          <th>Auksjon dato</th>
          <th>Dato generert</th>
          <th>Type</th>
          <th>Status</th>
        </tr>
      </thead>
      <tbody v-if="items.length < 1">
        <tr>
          <td>&nbsp;</td>
          <td colspan="8">
            <span v-if="!haveSearched">Spesifiser søket ved å benytte filter ovan...</span>
            <span v-else>Fann ingen resultatbrev...</span>
          </td>
        </tr>
      </tbody>
      <tbody v-else>
        <tr v-for="item in items" v-bind:key="item.id">
          <td>
            <div class="flex-container">
              <div class="input-container checkbox">
                <input type="checkbox" :value="item.id" v-model="selected">
                <span class="glyph"><svg viewBox="0 0 16 16"><use
                  xlink:href="/static/sprites.svg#glyph-input-checkbox"></use></svg></span>
              </div>
            </div>
          </td>
          <td>{{ item.id }}</td>
          <td>{{ item.Kundenr }}</td>
          <td>{{ item.template_data.Navn || '-' }}</td>
          <td>{{ item.Auksjonskode || '-' }}</td>
          <td>
            <span v-if="parseInt(item.Avdelingsid) === 0">
              {{item.Auksjonsdato | avantidate}}
            </span>
            <span v-else>
              {{item.Auksjonsdato | avantidatetime}}
            </span>
          </td>
          <td>{{ item.Registrert_dato | avantidate }}</td>
          <td>{{ item.AvantiType === 'automatic' ? 'E-post' : 'Manuell' }}</td>
          <td>
            <template v-if="item.AvantiType === 'automatic'">
              <span v-if="item.Status === 'draft'">Trenger godkjenning</span>
              <span v-if="item.Status === 'pending'">Godkjent, ligger i kø for utsending</span>
              <span v-if="item.Status === 'success'">Sendt</span>
              <span v-if="item.Status === 'failure'">Kunne ikke bli sendt</span>
              <span v-if="item.Status === 'processing'">Behandles nå</span>
            </template>
            <template v-else>
              <span v-if="item.Status === 'draft'">Ubehandlet</span>
              <span v-if="item.Status === 'pending'">Ubehandlet</span>
              <span v-if="item.Status === 'success'">Skrevet ut</span>
              <span v-if="item.Status === 'failure'">Feilet</span>
              <span v-if="item.Status === 'processing'">Skrives ut nå</span>
            </template>
          </td>
        </tr>
      </tbody>
      </table>

      <div class="pagination-container" v-show="pages > 1">
        <br>
        <paginate v-model="params.page"
          :page-count="pages"
          :page-range="5"
          :click-handler="changePage"
          :container-class="'pagination'"
          :prev-text="paginationArrow"
          :next-text="paginationArrow"
          :prev-class="'prev'"
          :next-class="'next'"
          >
        </paginate>
      </div>

      <div class="checkbox-panel-container" :class="{'active': selected.length > 0}">
        <div class="checkbox-panel">
          <div class="grid-x">
            <div class="cell auto">
              <div class="input-container checkbox">
                <input type="checkbox" id="checkall-objekter" @click="toggleSelectAll($event)" :checked="selected.length === items.length">
                <label for="checkall-objekter">Marker alle</label>
                <span class="glyph"><svg viewBox="0 0 16 16"><use xlink:href="/static/sprites.svg#glyph-input-checkbox"></use></svg></span>
              </div>
            </div>
            <div class="cell shrink">
              <span class="count"><span class="checked">{{selected.length}}</span> / <span class="total">{{items.length}}</span> markert</span>
            </div>
            <div class="cell shrink" v-if="!loading && !updating">
              <a href="javascript:;" @click="printSelected()" class="button primary">Vis / skriv ut</a>
            </div>
            <div class="cell shrink" v-else>
              <a href="javascript:;" class="button primary" disabled>Vis / skriv ut</a>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import TheAutoCompleteInputButtonOuter from '../../Inputs/TheAutoCompleteInputButtonOuter'
import TheAutoCompleteInputButton from '../../Inputs/TheAutoCompleteInputButton'
import InstillingerService from '@/services/InstillingerService'
import ResultatbrevService from '@/services/ResultatbrevService'
import AuksjonService from '@/services/AuksjonService'
import KundeService from '@/services/KundeService'
import moment from 'moment'
import bus from '@/plugins/event-bus'

export default {
  name: 'ResultatbrevHistorikk',
  $_veeValidate: {
    validator: 'new'
  },
  components: {
    TheAutoCompleteInputButtonOuter,
    TheAutoCompleteInputButton
  },
  data () {
    return {
      form: {
        Avdelingsid: null,
        Status: null,
        AvantiType: null,
        Auksjonskode: null,
        Auksjonsdato_fra: null,
        Auksjonsdato_til: null,
        Dato_fra: null,
        Dato_til: null,
        Kundenr: null
      },
      instillinger: {
        avdeling: [],
        status: [
          { key: null, val: 'Alle' },
          { key: 'pending', val: 'Godkjent, ligger i kø for utsending' },
          { key: 'processing', val: 'Behandles/skreves ut nå' },
          { key: 'success', val: 'Skrevet ut / sendt' },
          { key: 'failure', val: 'Feilet' }
        ],
        avantitypes: [
          { key: null, val: 'Alle' },
          { key: 'automatic', val: 'Automatisk e-post' },
          { key: 'manual', val: 'Manuell utskrift' }
        ]
      },
      auksjonInputValue: null,
      kundeInputValue: null,
      loading: false,
      updating: false,
      haveSearched: false,
      showAdvanced: false,
      items: [],
      pages: 1,
      params: {
        page: 1,
        sort: 'id',
        direction: 'desc',
        limit: 50
      },
      selected: []
    }
  },
  created () {
    bus.$off('search-resultatbrev')
    bus.$off('update-selected-status')
  },
  mounted () {
    bus.$on('search-resultatbrev', () => this.resetAndSearch())
    bus.$on('update-selected-status', () => this.updateSelectedStatus())

    this.setDefaultParams()
    this.init()
  },
  watch: {
    auksjonInputValue: function (newVal) {
      if (newVal === null || newVal === '') {
        this.form.Auksjonskode = null
      }
    },
    kundeInputValue: function (newVal) {
      if (newVal === null || newVal === '') {
        this.form.Kundenr = null
      }
    },
    isSubmittable: function (newVal) {
      if (!this.$store.getters.isFormProcessing) {
        this.$emit('onSubmitStatusChange', newVal ? 'submittable' : null)
      }
    }
  },
  computed: {
    selectedAvdeling: function () {
      if (this.form.Avdelingsid !== null) {
        return parseInt(this.form.Avdelingsid)
      }

      return null
    },
    isSubmittable: function () {
      if (!this.$store.getters.isFormSubmittable) {
        return false
      }

      if (this.selectedAvdeling !== null) {
        return true
      }

      return false
    }
  },
  methods: {
    formatDate: function (date, key) {
      if (this.form.hasOwnProperty(key)) {
        this.form[key] = new Date(moment(date).format('YYYY-MM-DD'))
      }
    },
    itemSoldCount: function (item) {
      if (this._.has(item.template_data.objects, 's')) {
        return Object.keys(item.template_data.objects.s).length
      }

      return 0
    },
    itemUnsoldCount: function (item) {
      if (this._.has(item.template_data.objects, 'u')) {
        return Object.keys(item.template_data.objects.u).length
      }

      return 0
    },
    onAuksjonSearchInput: function (query) {
      return AuksjonService.search(query, this.form.Avdelingsid)
    },
    onAuksjonSearchSelected: function (item) {
      if (item && item.Auksjon) {
        this.form.Auksjonskode = item.Auksjon
        this.auksjonInputValue = item.Auksjon
      } else {
        this.form.Auksjonskode = null
        this.auksjonInputValue = null
      }
    },
    onAuksjonSearchReset: function () {
      this.form.Auksjonskode = null
      this.auksjonInputValue = null
    },
    onKundeSearchInput: function (query) {
      return KundeService.search(query)
    },
    onKundeSearchSelected: function (item) {
      if (item) {
        this.kundeInputValue = (item.Bedrift ? item.FirmaNavn : item.full_name) || item.Kundenr
        this.form.Kundenr = item.Kundenr
      } else {
        this.kundeInputValue = null
        this.form.Kundenr = null
      }
    },
    onKundeSearchReset: function () {
      this.kundeInputValue = null
      this.form.Kundenr = null
    },
    init: function () {
      this.setFormLoading(true)
      this.$emit('onSubmitStatusChange', 'loading')

      // Load avdeling instillinger
      this.instillinger.avdeling.unshift({key: this.form.avdeling, val: 'Laster...'})

      InstillingerService('avdeling').dropdown()
        .then((response) => {
          this.instillinger.avdeling = response.data
          this.instillinger.avdeling.unshift({key: null, val: 'Velg avdeling', disabled: true})
        })
        .catch(() => {
          this.$helpers.showErrorAlert('Feil', 'Kunne ikke laste ned innstillinger')
        })
        .then(() => {
          this.setFormLoading(false)
          this.$emit('onSubmitStatusChange', this.isSubmittable ? 'submittable' : null)
        })
    },
    changePage: function (page) {
      this.updating = true
      this.params.page = page

      this.handleSubmit()
    },
    setDefaultParams: function () {
      this.params = {
        page: 1,
        sort: 'id',
        direction: 'desc',
        limit: 50
      }
    },
    resetAndSearch: function () {
      this.updating = true
      // this.$emit('onSubmitStatusChange', 'loading')
      this.setDefaultParams()
      this.handleSubmit()
    },
    handleSubmit: function () {
      if (!this.isSubmittable) {
        return
      }

      // Reset selected
      this.selected = []

      this.$emit('onSubmitStatusChange', 'processing')
      this.setFormProcessing(true)

      this.$validator.validateAll()
        .then((result) => {
          if (!result) {
            // Validation Failed
            this.setFormProcessing(false)
            this.$helpers.showErrorAlert('Feil', 'Vennligst korriger feil i skjemaet')
          } else {
            const post = this._.clone(this.form)
            // if (!this.form.Kundenr && this.kundeInputValue) {
            //   post.kundesearch = this.kundeInputValue
            // }

            ResultatbrevService.search(this.params, post)
              .then((response) => {
                this.pages = response.headers['x-paging-pagecount'] ? parseInt(response.headers['x-paging-pagecount']) : 1
                this.items = response.data
              })
              .catch(() => {
                this.$helpers.showErrorAlert('Feil', 'Kunne ikke laste inn liste')
              })
              .then(() => {
                this.loading = false
                this.updating = false
                this.haveSearched = true
                this.setFormProcessing(false)
                this.$emit('onSubmitStatusChange', 'submittable')
              })
          }
        })
    },
    toggleSelectAll: function (event) {
      if (event.target.checked) {
        // Checked: true -> add all objektids to the selected-array
        this.selected = []
        this.items.forEach(i => {
          this.selected.push(i.id)
        })
      } else {
        // Just empty selected-array
        this.selected = []
      }
    },
    printSelected: function () {
      this.openModal('resultatbrev-print-modal', { items: this.selected, internalWindow: true, skipSave: true }, 'split')
    }
  }
}
</script>
<style scoped>
  .show-more-opts {
    display: block;
    margin-top: 0.82rem;
    font-size: 0.75rem;
  }

  .pagination-container {
    margin-top: 2.25rem;
  }
</style>



// WEBPACK FOOTER //
// src/components/Admin/Reports/ResultatbrevHistorikk.vue